module.exports = __webpack_public_path__ + "static/img/icon-coupon-ticket.5cf469f8.png";